import ProjectsList from '~/projects_list';

document.addEventListener('DOMContentLoaded', () => new ProjectsList());
